"use client";

import { ApplyNowEmailCapture } from "@/components/forms/apply-now-email-capture";
import {
  EMAIL_CAPTURE_PILL_FORM_CLASS,
  EMAIL_CAPTURE_PILL_INPUT_CLASS,
} from "@/components/forms/email-capture-pill-styles";
import { cn } from "@/lib/utils";

interface HeroApplyNowFormProps {
  emailPlaceholder: string;
  ctaLabel: string;
  sendingLabel?: string;
  className?: string;
}

export function HeroApplyNowForm({
  emailPlaceholder,
  ctaLabel,
  sendingLabel = "Sending…",
  className,
}: HeroApplyNowFormProps) {
  return (
    <ApplyNowEmailCapture
      id="hero-email"
      emailPlaceholder={emailPlaceholder}
      applyLabel={ctaLabel}
      sendingLabel={sendingLabel}
      buttonLayout="hero-form"
      allowEmptyEmail
      formClassName={cn(
        EMAIL_CAPTURE_PILL_FORM_CLASS,
        "border-grey-300 bg-grey-0 mt-1 max-w-[426px]",
        "focus-within:border-grey-500 transition-colors",
        className
      )}
      inputClassName={EMAIL_CAPTURE_PILL_INPUT_CLASS}
    />
  );
}
